import { toURLSearchParams } from '@wix/sdk-runtime/rest-modules';
import { transformSDKDurationToRESTDuration } from '@wix/sdk-runtime/transformations/duration';
import { transformRESTDurationToSDKDuration } from '@wix/sdk-runtime/transformations/duration';
import { transformPaths } from '@wix/sdk-runtime/transformations/transform-paths';
import { resolveUrl } from '@wix/sdk-runtime/rest-modules';
import { ResolveUrlOpts } from '@wix/sdk-runtime/rest-modules';
import { RequestOptionsFactory } from '@wix/sdk-types';

function resolveWixCoreservicesLongTypesV1LongTypesServiceUrl(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {
    'apps._base_domain_': [
      {
        srcPath: '/_api/metro-inspector',
        destPath: '/api',
      },
    ],
    'api._api_base_domain_': [
      {
        srcPath: '/metro-inspector',
        destPath: '',
      },
    ],
    'www._base_domain_': [
      {
        srcPath: '/metro-inspector',
        destPath: '/api',
      },
    ],
    'manage._base_domain_': [
      {
        srcPath: '/metro-inspector',
        destPath: '',
      },
    ],
    'www.wixgateway.com': [
      {
        srcPath: '/_api/metro-inspector',
        destPath: '/api',
      },
    ],
    _: [
      {
        srcPath: '/_api/metro-inspector',
        destPath: '/api',
      },
    ],
    'www.wixapis.com': [
      {
        srcPath: '/_api/metro-inspector',
        destPath: '/api',
      },
      {
        srcPath: '/metro-inspector',
        destPath: '',
      },
    ],
    'editor._base_domain_': [
      {
        srcPath: '/metro-insepctor',
        destPath: '',
      },
      {
        srcPath: '/_api/metro-inspector',
        destPath: '/api',
      },
    ],
    'blocks._base_domain_': [
      {
        srcPath: '/metro-insepctor',
        destPath: '',
      },
      {
        srcPath: '/_api/metro-inspector',
        destPath: '/api',
      },
    ],
    'create.editorx': [
      {
        srcPath: '/metro-insepctor',
        destPath: '',
      },
      {
        srcPath: '/_api/metro-inspector',
        destPath: '/api',
      },
    ],
    'dev._base_domain_': [
      {
        srcPath: '/_api/metro-inspector',
        destPath: '',
      },
    ],
    'bo._base_domain_': [
      {
        srcPath: '/_api/metro-inspector',
        destPath: '',
      },
    ],
    'wixbo.ai': [
      {
        srcPath: '/_api/metro-inspector',
        destPath: '',
      },
    ],
    'wix-bo.com': [
      {
        srcPath: '/_api/metro-inspector',
        destPath: '',
      },
    ],
  };

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

const PACKAGE_NAME = '@wix/auto_sdk_core-services-d_echo';

/** echo given arg1 and arg2 */
export function publicLongEcho(payload: object): RequestOptionsFactory<any> {
  function __publicLongEcho({ host }: any) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKDurationToRESTDuration,
        paths: [{ path: 'durationField' }],
      },
    ]);
    const metadata = {
      entityFqdn: 'wix.metroinspector.v1.long',
      method: 'GET' as any,
      methodFqn:
        'wix.coreservices.longTypes.v1.LongTypesService.PublicLongEcho',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixCoreservicesLongTypesV1LongTypesServiceUrl({
        protoPath: '/v1/public-long',
        data: serializedData,
        host,
      }),
      params: toURLSearchParams(serializedData),
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTDurationToSDKDuration,
            paths: [{ path: 'durationField' }],
          },
        ]),
    };

    return metadata;
  }

  return __publicLongEcho;
}
